<h1 mat-dialog-title>Disconnect While Idle</h1>
<div mat-dialog-content>
  Disconnected from server while you are idle. Select "Ok" to reconnect.
</div>
<div mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="reload()" cdkFocusInitial>
    Ok
  </button>
</div>
